export default __webpack_public_path__ + "static/media/logo.72ceb6cd.png";